import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { Stack } from 'syf-component-library/ui/spacing';
import { useAccountFeaturesQuery } from '@syf-api-library/account-features';
import { useEffect, useState } from 'react';
import { useProfileQuery } from '@syf-api-library/profile';
import { InlineCtaButton, ReplacementCardOnlineChatButton } from '../../components/Button';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import { DeliveryDetailBlock, DigitalCardBanner, RequestDetails } from '../../components/SummaryDetails';
import { t } from '../../translations/getTranslation';
import useConfig from '../../context/config.context';
import useCardholders from '../../hooks/useCardholders';
import { formatAddress } from '../../helpers/format';
import useAccountSummary from '../../hooks/useAccountSummary';
import useAnalytics from '../../hooks/useAnalytics';
import useFeatureFlagsQuery from '../../hooks/useFeatureFlagsQuery';
import useSteps from '../../context/steps.context';
import Alert from '../../components/Alert';
import { useStore } from '../../zustandStore/store';
import useCardAccessLink from '../../hooks/useCardAccessLink';
const Paragraph = styled.p `
  margin-top: ${({ theme, $baseGap }) => $baseGap ? theme.spacing.base : theme.spacing.large}px;
  font-size: ${({ theme }) => theme.fontSizes.root}px;
  line-height: ${({ theme }) => theme.lineHeights.root};
  text-align: ${({ $center }) => $center && 'center'};
`;
const CustomAlert = styled(Alert) `
  margin-bottom: ${({ theme }) => theme.spacing.large}px;

  span {
    font-weight: ${({ theme }) => theme.fontWeights.bold};
  }
`;
const Confirmation = () => {
    var _a;
    const { config, accountId, navigationHandler } = useConfig();
    const { stepsDispatch } = useSteps();
    const { replacedCardholders } = useStore();
    const { data: accountFeatures, isLoading: accountFeaturesLoading } = useAccountFeaturesQuery({
        config,
        keyProps: { accountId, accountIdType: 'guid' }
    });
    const { stepsState: { previousSteps } } = useSteps();
    const currentFlow = previousSteps.includes('SelectAccount')
        ? 'SelectAccount'
        : 'SelectCardholder';
    const { isLoading: cardHoldersLoading } = useCardholders(currentFlow);
    const { data } = useProfileQuery({
        config,
        keyProps: { accountId, accountIdType: 'guid' }
    });
    const { data: featureFlags } = useFeatureFlagsQuery();
    const shippingAddress = (data === null || data === void 0 ? void 0 : data.profile.mailingAddress)
        ? formatAddress(data.profile.mailingAddress)
        : '';
    const [fireAnalytics, setFireAnalytics] = useState(false);
    const { accountName, isSuccess: accountSummarySuccess, isSemu } = useAccountSummary();
    useEffect(() => {
        if (!accountFeaturesLoading &&
            !cardHoldersLoading &&
            accountSummarySuccess) {
            setFireAnalytics(true);
        }
    }, [accountFeaturesLoading, cardHoldersLoading, accountSummarySuccess]);
    useAnalytics(fireAnalytics, { isSemu });
    const { cardAccessUrl } = useCardAccessLink();
    const hasReplacementCardUrl = !!cardAccessUrl;
    const showCardAccessBanner = (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.config.flags.showCardAccessBanner) &&
        hasReplacementCardUrl &&
        ((_a = accountFeatures === null || accountFeatures === void 0 ? void 0 : accountFeatures.walletDetails) === null || _a === void 0 ? void 0 : _a.accessToSyf);
    const failedCardHolders = replacedCardholders
        .filter(cardholder => !cardholder.replaced)
        .map(cardHolder => cardHolder.name)
        .join(', ');
    const successCardholders = replacedCardholders.filter(cardholder => cardholder.replaced);
    if (!successCardholders.length) {
        stepsDispatch({ type: 'updateStep', payload: 'UnableSubmit' });
        return null;
    }
    const handleClick = () => {
        if (navigationHandler) {
            navigationHandler('track-your-card');
        }
    };
    return (_jsxs(MainLayout, Object.assign({ withImage: true }, { children: [!!failedCardHolders.length && (_jsxs(CustomAlert, Object.assign({ variant: "error" }, { children: [_jsx("span", { children: t('summaryDetails.cardholderRequestFailed') }), failedCardHolders] }))), _jsx(LayoutHeading, { title: t('summaryDetails.yourReplacementHasBeen'), modalImageProps: { imageName: 'CHECKMARK' } }), _jsx(Paragraph, { children: t('summaryDetails.wellNotifyYou', {
                    email: (data === null || data === void 0 ? void 0 : data.profile['cipher.email']) || ''
                }) }), _jsxs(Paragraph, Object.assign({ "$center": true, "$baseGap": true }, { children: [t('summaryDetails.needMoreHelp'), _jsx(ReplacementCardOnlineChatButton, {}), t('summaryDetails.toCommunicateWithUs')] })), _jsx(Stack, { size: "large" }), _jsx(RequestDetails, { cardholders: successCardholders, accountName: accountName || '' }), _jsx(Stack, { size: "large" }), _jsx(DeliveryDetailBlock, { heading: t('summaryDetails.shippingAddress'), paragraphs: [shippingAddress] }), showCardAccessBanner && (_jsxs(_Fragment, { children: [_jsx(Stack, { size: "large" }), _jsx(DigitalCardBanner, {})] })), (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.config.flags.showTrackYourCard) && (_jsxs(Paragraph, { children: [t('summaryDetails.toCheckYourCard'), _jsx(InlineCtaButton, Object.assign({ "data-type": "replacement card", "data-reason": "track your card", "data-object": "link", "data-analytics": "clicktrackingevent", onClick: handleClick }, { children: t('summaryDetails.trackYourCard') })), t('summaryDetails.itCanTake')] }))] })));
};
export default Confirmation;
//# sourceMappingURL=index.js.map